import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import InputText from '../../../form/input/text';
import InputSubmit from '../../../form/input/submit';

import { accountRoute } from '../../../../routes';

import { dispatchMsg } from '../../../../actions/errors';

export default class ProfileSignedIn extends Component {
	static PropTypes = {
		user: PropTypes.object.isRequired,
	};

	render() {
		return (
			<div>
				<div className=''>
					<div className='nav-profile__label'>Signed in as:</div>

					<Link to={accountRoute('')} className='nav-profile__name' onClick={ () => this.props.toggleMenu() }>
						{this.props.user.name}
					</Link>

					<a className='button button--go nav-profile__button-signout' onClick={() => {
						this.props.logout();
						let _this = this;

						this.props.dispatch(dispatchMsg({
							message: 'Successfully logged out.',
						}));

						setTimeout(function() {
							_this.props.toggleMenu();
						}, 2000);
					}}>
						Sign out
					</a>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/menu/profile/profileSignedIn.js
 **/